import css from "styled-jsx/css";

export const componentStyles = css`
  .building-blocks-content-wrapper {
    opacity: 0;
    transition: 0.3s;
    // keep 1st child relative to determine the component size
    &:not(:first-child) {
      position: absolute;
      top: 0;
      left: 0;
    }
    &.selected {
      opacity: 1;
    }
  }
`;
